"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _antd = require("antd");

var _moment = require("../../utils/moment");

var _FormGroup = _interopRequireDefault(require("../FormGroup"));

var _FormControlMessage = _interopRequireDefault(require("../FormControlMessage"));

var _Label = _interopRequireDefault(require("../Label"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _utils = require("../../utils");

var _constants = require("./constants");

var _propTypes2 = require("./propTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** A basic widget to work with date and time.
 *
 * DO Always use labels on text inputs and don’t depend on the placeholder
 * text. If there is more information for the text input needed make
 * use of a paragraph on top or use an info box. */
function DatePicker(props) {
  var disabled = props.disabled,
      error = props.error,
      label = props.label,
      dropdownClassName = props.dropdownClassName,
      labelInfobox = props.labelInfobox,
      required = props.required,
      popupPosition = props.popupPosition,
      children = props.children,
      format = props.format,
      defaultValue = props.defaultValue,
      value = props.value,
      onChange = props.onChange,
      labels = props.labels,
      helpText = props.helpText,
      rest = _objectWithoutProperties(props, ["disabled", "error", "label", "dropdownClassName", "labelInfobox", "required", "popupPosition", "children", "format", "defaultValue", "value", "onChange", "labels", "helpText"]);

  var _useState = (0, _react.useState)(defaultValue ? (0, _moment.moment)((0, _moment.moment)(defaultValue).format(format), format) : (0, _moment.moment)()),
      _useState2 = _slicedToArray(_useState, 2),
      valueInput = _useState2[0],
      setValueInput = _useState2[1];

  var inputRef = (0, _react.useRef)(null);

  var onChangeDate = function onChangeDate(date, dateString) {
    setValueInput((0, _moment.moment)(dateString, format));
    onChange(date, dateString);
  };

  (0, _react.useEffect)(function () {
    if (value) {
      setValueInput((0, _moment.moment)((0, _moment.moment)(value).format(format), format));
    }
  }, [value]);
  var dropdownClass = (0, _utils.getClassNames)(dropdownClassName, popupPosition === 'top' ? 'datepicker-top' : 'datepicker');
  return /*#__PURE__*/_react.default.createElement(_FormGroup.default, {
    disabled: disabled,
    error: error
  }, label && /*#__PURE__*/_react.default.createElement(_Label.default, {
    htmlFor: label,
    label: label,
    labelInfobox: labelInfobox,
    required: required,
    helpText: helpText
  }), /*#__PURE__*/_react.default.createElement(_antd.DatePicker, _extends({}, rest, {
    locale: labels,
    allowClear: false,
    id: label,
    ref: inputRef,
    value: valueInput,
    format: format,
    className: error ? 'ant-input_invalid' : null,
    dropdownClassName: dropdownClass,
    suffixIcon: /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      type: "calendar",
      size: 36
    })),
    disabled: disabled,
    required: required,
    onChange: onChangeDate,
    defaultValue: (0, _moment.moment)(defaultValue, format)
  })), error && /*#__PURE__*/_react.default.createElement(_FormControlMessage.default, null, error), children && /*#__PURE__*/_react.default.createElement("p", null, children));
}

DatePicker.propTypes = {
  /** The label text */
  label: _propTypes.default.string,

  /** The text displayed if the label tooltip exist */
  labelInfobox: _propTypes.default.bool,

  /** The placeholder text */
  placeholder: _propTypes.default.string,

  /** The datepicker popup positioning. */

  /** Set to 'top' if date field is at the end of form */
  popupPosition: _propTypes.default.string,

  /** @ignore */
  defaultValue: _propTypes.default.string,

  /** @ignore */
  value: _propTypes.default.string,

  /** @ignore */
  disabled: _propTypes.default.bool,

  /** If required field* */
  required: _propTypes.default.bool,

  /** The error message displayed if the input is errored */
  error: _propTypes.default.string,

  /** localization object */
  labels: _propTypes2.datePickerLocalePropTypes,

  /** @ignore */
  children: _propTypes.default.node,

  /** @ignore */
  format: _propTypes.default.string,

  /** @ignore */
  onChange: _propTypes.default.func,

  /** @ignore */
  dropdownClassName: _propTypes.default.string,

  /** The text displayed if the label tooltip exist */
  helpText: _propTypes.default.bool
};
DatePicker.defaultProps = {
  label: null,
  labelInfobox: false,
  placeholder: null,
  popupPosition: 'bottom',
  defaultValue: undefined,
  value: null,
  disabled: false,
  required: false,
  error: null,
  children: null,
  format: 'DD-MM-YYYY',
  onChange: function onChange() {},
  dropdownClassName: undefined,
  labels: _constants.defaultDatePickerLocale,
  helpText: null
};
var _default = DatePicker;
exports.default = _default;